<template>
    <div class="wrapper wrapper-content animated fadeInRight">
        <el-form :model="detailInfo" ref="detailInfo" label-width="0px" class="demo-dynamic form-horizontal detailPage">
            <el-tabs type="border-card" v-model="pageLangCode">
                <el-tab-pane :name="langItem.langCode" :label="$t('message.' + langItem.langCode)"
                    v-for="(langItem, index) in detailInfo.lstPublicityLangMapDTO" :key="index">
                    <div class="panel-body">
                        <div class="ibox-content">
                            <div class="form-group">
                                <label class="col-sm-2 control-label">
                                    Parent
                                </label>
                                <div class="col-sm-4">
                                    <el-form-item prop="parentId" :rules="{
                                        required: true, message: $t('message.required'), trigger: 'change'
                                    }">
                                        <el-select v-model="detailInfo.parentId"
                                            v-bind:placeholder='$t("message.PleaseSelect")'>
                                            <el-option v-for="item in parentList" :key="item.id" :label="item.title"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label">
                                    Title
                                </label>
                                <div class="col-sm-10">
                                    <el-form-item :prop="'lstPublicityLangMapDTO.' + index + '.title'" :rules="{
            required: true,
            message: $t('message.required'),
            trigger: 'blur'
        }">
                                        <el-input v-model="langItem.title" show-word-limit></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label"> Cover Image </label>
                                <div class="col-sm-10">
                                    <el-upload class="upload-demo upload-image" action="#" multiple
                                        :http-request="(e) => { uploadFile(e, index, 'image') }" :auto-upload="true"
                                        accept=".png, .jpg , .jpeg" :show-file-list="false">
                                        <div slot="tip" v-if="imageUploadErr" style="color:red;font-size:10px;"
                                            class="el-upload__tip">The uploaded
                                            file should not exceed 5MB</div>
                                        <div class="input-group img-group">
                                            <div class="text-center dropzone logo">
                                                <div class="addImage" v-if="!langItem.showCoverImage"
                                                    style="width: 100%; padding-top: 25px; color: #fff">
                                                    <a class="addImageIcon btn btn-primary btn-circle">
                                                        <i class="el-icon-upload2"></i>
                                                    </a>
                                                    <p class="text-primary m-t-sm font14 suggestFont">
                                                        <slot name="sizeHint"></slot>
                                                    </p>
                                                </div>
                                                <div class="editImage" v-if="langItem.showCoverImage">
                                                    <div class="mask-bg"></div>
                                                    <img :src="langItem.showCoverImage" />
                                                    <div class="icon-center">
                                                        <span class="edit-icon">
                                                            <i class="el-icon-edit"></i>
                                                        </span>
                                                        <p class="font14 font-white editFont">Modify</p>
                                                        <p class="text-primary font-white m-t-sm font14 suggestFont">
                                                            <slot name="sizeHint"></slot>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </el-upload>
                                    <el-form-item :prop="'lstPublicityLangMapDTO.' + index + '.showCoverImage'" :rules="{
            required: true,
            message: $t('message.required'),
            trigger: 'change',
        }">
                                        <el-input style="display: none" v-model="langItem.showCoverImage"
                                            show-word-limit></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label">
                                    Intro
                                </label>
                                <div class="col-sm-10">
                                    <el-form-item :prop="'lstPublicityLangMapDTO.' + index + '.intro'" :rules="{
            required: true,
            message: $t('message.required'),
            trigger: 'blur'
        }">
                                        <el-input v-model="langItem.intro" show-word-limit></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label">
                                    Description
                                </label>
                                <div class="col-sm-10">
                                    <el-form-item :prop="'lstPublicityLangMapDTO.' + index + '.content'" :rules="{
            required: true,
            message: $t('message.required'),
            trigger: 'blur'
        }">
                                        <ckeditor :editor="editor" @ready="onReady" v-model="langItem.content"
                                            :config="editorConfig"></ckeditor>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label">
                                    Picture / Video
                                </label>
                                <div class="col-sm-10" style="display: flex">
                                    <uploadVideoOrPicture :inputFileList="langItem.videoImgList"
                                        @changeList="hadnleChangeImages($event, index)"></uploadVideoOrPicture>
                                    <!-- <vuedraggable v-model="langItem.lstPublicityImagesDTO" class="drag">
                                        <transition-group>
                                            <div class="dragInfo" v-for="item in langItem.lstPublicityImagesDTO"
                                                :key="item.fileUrl">
                                                <el-image :src="item.showFileUrl"></el-image>
                                                <i class="el-icon-delete dragDelete" @click="handleRemove(item, index)"></i>
                                            </div>
                                        </transition-group>
                                    </vuedraggable>

                                    <el-upload action="#" :http-request="(params) => { uploadFile(params, index, 'image') }"
                                        :file-list="langItem.lstPublicityImagesDTO"
                                        v-if="langItem.lstPublicityImagesDTO.length < 5" list-type="picture-card"
                                        accept=".png, .jpg , .jpeg" :auto-upload="true" :show-file-list="false">
                                        <div slot="tip" v-if="uploadErr" style="color: red; font-size: 10px"
                                            class="el-upload__tip">
                                            The uploaded file should not exceed 5MB
                                        </div>
                                        <i slot="default" class="el-icon-plus"></i>
                                        <div slot="file" slot-scope="{ file }">
                                            <img class="el-upload-list__item-thumbnail" :src="file.showFileUrl" alt="" />
                                            <span class="el-upload-list__item-actions">
                                                <span class="el-upload-list__item-delete"
                                                    @click="handleRemove(file, index)">
                                                    <i class="el-icon-delete"></i>
                                                </span>
                                            </span>
                                        </div>
                                    </el-upload> -->
                                </div>
                                <label class="col-sm-2 control-label"></label>
                                <el-form-item class="col-sm-10"
                                    :prop="'lstPublicityLangMapDTO.' + index + '.imageListIsNull'" :rules="{
            required: true,
            message: $t('message.required'),
            trigger: ['blur', 'change'],
        }">
                                    <el-input style="display: none;" v-model="langItem.imageListIsNull"
                                        show-word-limit></el-input>
                                </el-form-item>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label">
                                    File
                                </label>
                                <div class="col-sm-10">
                                    <el-upload action="#" multiple
                                        :http-request="(params) => { uploadFile(params, index, 'document') }"
                                        :auto-upload="true"
                                        :on-remove="(file, fileList) => { handleRemoveDocument(file, fileList, index) }"
                                        accept=".doc, .DOC, .DOCX, .pdf, .PDF, .xls, XLS, xlsx, XLSX, .ppt, .PPT, .pptx, .PPTX, .ZIP"
                                        :file-list="langItem.lstPublicityAttachmentDTO" :limit="1">
                                        <div slot="tip" v-if="uploadErr" style="color: red; font-size: 10px"
                                            class="el-upload__tip">
                                            The uploaded file should not exceed 5MB
                                        </div>
                                        <el-button size="small" type="primary">Upload</el-button>
                                    </el-upload>
                                    <el-form-item :prop="'lstPublicityLangMapDTO.' + index + '.documentListIsNull'"
                                        :rules="{
            required: false,
            message: $t('message.required'),
            trigger: ['blur', 'change'],
        }">
                                        <el-input style="display: none;" v-model="langItem.documentListIsNull"
                                            show-word-limit></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label">
                                    External Url
                                </label>
                                <div class="col-sm-10">
                                    <el-form-item :prop="'lstPublicityLangMapDTO.' + index + '.externalUrl'" :rules="{
            required: false,
            message: $t('message.required'),
            trigger: 'blur'
        }">
                                        <el-input v-model="langItem.externalUrl" show-word-limit></el-input>
                                    </el-form-item>
                                </div>
                            </div>

                            <el-divider></el-divider>
                            <div class="form-group">
                                <label class="col-sm-2 control-label">
                                    Date
                                </label>
                                <div class="col-sm-4">
                                    <el-form-item prop="selectDate" :rules="{
            required: true, message: $t('message.required'), trigger: 'change'
        }">
                                        <el-date-picker v-model="detailInfo.selectDate" type="daterange"
                                            start-placeholder="Start date" end-placeholder="End date">
                                        </el-date-picker>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label">
                                    Category
                                </label>
                                <div class="col-sm-4">
                                    <el-form-item prop="subCategory" :rules="{
            required: true, message: $t('message.required'), trigger: 'change'
        }">
                                        <el-select v-model="detailInfo.subCategory"
                                            v-bind:placeholder='$t("message.PleaseSelect")'>
                                            <el-option v-for="item in subCategoryList" :key="item.id" :label="item.name"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label">
                                    Provide Name
                                </label>
                                <div class="col-sm-10">
                                    <el-form-item prop="provideName" :rules="{
            required: false,
            message: $t('message.required'),
            trigger: 'blur'
        }">
                                        <el-input disabled v-model="detailInfo.provideName" show-word-limit></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label">
                                    Provide Dept
                                </label>
                                <div class="col-sm-10">
                                    <el-form-item prop="provideDept" :rules="{
            required: false,
            message: $t('message.required'),
            trigger: 'blur'
        }">
                                        <el-input disabled v-model="detailInfo.provideDept" show-word-limit></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label">
                                    Provide Tel
                                </label>
                                <div class="col-sm-10">
                                    <el-form-item prop="provideTel" :rules="{
            required: false,
            message: $t('message.required'),
            trigger: 'blur'
        }">
                                        <el-input disabled v-model="detailInfo.provideTel" show-word-limit></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label">
                                    Provide Email
                                </label>
                                <div class="col-sm-10">
                                    <el-form-item prop="provideEmail" :rules="{
            required: false,
            message: $t('message.required'),
            trigger: 'blur'
        }">
                                        <el-input disabled v-model="detailInfo.provideEmail" show-word-limit></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label">
                                    Status
                                </label>
                                <div class="col-sm-4">
                                    <el-form-item prop="status" :rules="{
            required: false, message: $t('message.required'), trigger: 'change'
        }">
                                        <el-select v-model="detailInfo.status" disabled
                                            v-bind:placeholder='$t("message.PleaseSelect")'>
                                            <el-option v-for="item in statusMap" :key="item.value" :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="hr-line-dashed"></div>
                            <div class="form-group">
                                <div class="col-sm-12">
                                    <div class="pull-right">
                                        <el-button :disabled="!(
            !detailInfo.status ||
            detailInfo.status == 3 ||
            detailInfo.status == 4
        )
            " type="primary" @click="checkEvent()">Save</el-button>
                                        <el-button @click="showWarning()">{{
            $t("message.Cancel")
        }}</el-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </el-form>
    </div>
</template>
<script>
import config from "../config";
import ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import vuedraggable from "vuedraggable";
import uploadVideoOrPicture from "../components/uploadVideoOrPicturePublicity/index";
export default {
    mixins: [config.globalMixin],
    components: { vuedraggable, uploadVideoOrPicture },
    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {
                toolbar: ['Heading', 'bold', 'italic', 'underline', 'Link', 'bulletedList', 'numberedList'],
                // The configuration of the editor.
            },
            parentList:[],
            detailInfo: {
                lstPublicityLangMapDTO: [],
                begDate: "",
                endDate: "",
                id: null,
                parentId: null,
                status: 0,
                subCategory: '',
                selectDate: null,
                parentId: null,
                provideEmail: '',
                provideTel: '',
                provideDept: '',
                provideName: ''

            },
            uploadErr: false,
            imageUploadErr: false,
            pageLangCode: 'en_US',
            subCategoryList: []
        };
    },
    computed: {
        _language() {
            return this.$store.state.userInfo.langCode;
        },
        statusMap() {
            return [
                { label: 'Draft', value: 0 },
                { label: 'Pending approval', value: 1 },
                { label: 'Pending Publish', value: 2 },
                { label: 'Rejected', value: 3 },
                { label: 'Suspended', value: 4 },
                { label: 'Pending Suspend', value: 5 },
                { label: 'Published', value: 6 },
            ]
        }
    },
    watch: {
        detailInfo: {
            handler: function () {
                this.$store.state.edit = true;
            },
            deep: true
        }
    },
    async created() {
        var obj = [];
        for (var i = 0; i < this.$store.state.userInfo.language.length; i++) {
            obj.push({
                langCode: this.$store.state.userInfo.language[i].langCode,
                content: "",
                coverImage: '',
                externalUrl: '',
                intro: '',
                lstPublicityAttachmentDTO: [],
                lstPublicityImagesDTO: [
                    // fileType:1,
                    // fileUrl:'',
                    // fkPublicityLangMapId:'',
                    // showFileUrl:'',
                    // sortOrder:''
                ],
                videoImgList: [],
                showCoverImage: '',
                title: '',
                documentListIsNull: '',
                imageListIsNull: ''
            });
        }
        this.$set(this.detailInfo, "lstPublicityLangMapDTO", obj);
        await this.getParentList()
        await this.getSubCategory()
        this.init();
    },
    mounted() { this.setBreadcrumbs() },
    methods: {
        handleRemoveDocument(file, fileList, langIndex) {
            this.detailInfo.lstPublicityLangMapDTO[langIndex].lstPublicityAttachmentDTO = fileList
        },
        async getSubCategory() {
            var objdata = this.getAuthObj();
            objdata.pageIndex = 1;
            objdata.pageSize = 9999;
            objdata.name = ''
            objdata.type = "publicity_category"

            objdata.apiUrl = this.apiConfig.publicityCategoryList;
            let data = await this.$store.dispatch("apiEvent", objdata);
            if (data == "000104") {
                this.timeoutEvent();
                return;
            }
            if (!data) return;
            this.subCategoryList = data.data.result.codeList;
        },
        async getParentList() {
            this.canDrag = true;
            var objdata = this.getAuthObj();

            objdata.pageIndex = 1;
            objdata.pageSize = 99999;
            objdata.title = '';
            objdata.parentId = 0

            objdata.apiUrl = this.apiConfig.publicityList;
            let data = await this.$store.dispatch("apiEvent", objdata);
            if (data == "000104") {
                this.timeoutEvent();
                return;
            }
            if (!data) return;
            this.parentList = data.data.result.publicityList;
        },
        onReady(editor) {
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        // handleRemove(file, langIndex) {
        //     var index = "";
        //     this.detailInfo.lstPublicityLangMapDTO[langIndex].lstPublicityImagesDTO.forEach((item, i) => {
        //         if (item.imageUrl == file.imageUrl) {
        //             index = i;
        //         }
        //     });
        //     this.detailInfo.lstPublicityLangMapDTO[langIndex].lstPublicityImagesDTO.splice(index, 1);
        //     if (!this.detailInfo.lstPublicityLangMapDTO[langIndex].lstPublicityImagesDTO.length) this.detailInfo.lstPublicityLangMapDTO[langIndex].imageListIsNull = ''
        //     this.$forceUpdate()
        // },
        async uploadFile(params, index, type) {
            if (!this.handleCheckUploadFileSize(params.file, type)) return false
            let obj = this.getAuthObj();
            obj.file = params.file;
            obj.apiUrl = this.apiConfig.upload;
            var data = await this.$store.dispatch("apiEventFromData", obj);
            if (data == this.TOKEN_EXPIRED) {
                this.timeoutEvent();
                return;
            }
            if (!data) return;
            if (type == 'image') {
                this.detailInfo.lstPublicityLangMapDTO[index].coverImage = data.data.result.url;
                this.detailInfo.lstPublicityLangMapDTO[index].showCoverImage = data.data.result.showUrl;
            } else {
                this.getObject(
                    this.detailInfo.lstPublicityLangMapDTO,
                    this.pageLangCode
                ).lstPublicityAttachmentDTO.push({
                    fileUrl: data.data.result.url,
                    showFileUrl: data.data.result.showUrl,
                    name: params.file.name,
                    fileName: params.file.name,
                    fileType: 2
                });
                this.getObject(
                    this.detailInfo.lstPublicityLangMapDTO,
                    this.pageLangCode
                ).documentListIsNull = 'no'
                const refForm = this.$refs["detailInfo"]
                this.$nextTick(() => {
                    setTimeout(function () {
                        refForm.clearValidate('lstPublicityLangMapDTO.' + index + '.documentListIsNull')
                    }, 200);
                })
            }
            this.$forceUpdate()
        },
        hadnleChangeImages(resList, index) {
            this.getObject(
                this.detailInfo.lstPublicityLangMapDTO,
                this.pageLangCode
            ).videoImgList = resList
            this.getObject(
                this.detailInfo.lstPublicityLangMapDTO,
                this.pageLangCode
            ).imageListIsNull = 'no'
            const refForm = this.$refs["detailInfo"]
            this.$nextTick(() => {
                setTimeout(function () {
                    refForm.clearValidate('lstPublicityLangMapDTO.' + index + '.imageListIsNull')
                }, 100);
            })
            this.$forceUpdate()
        },
        handleCheckUploadFileSize(file, type) {
            const sizeKB = file.size / 1024
            if (sizeKB > 5120) {
                if (type == 'image') this.imageUploadErr = true
                else this.uploadErr = true
                return false
            } else {
                if (type == 'image') this.imageUploadErr = false
                else this.uploadErr = false
                return true
            }
        },
        setObj: function () {

        },
        async init() {
            let id = this.$route.query.id;
            var that = this;
            if (id) {
                let obj = this.getAuthObj();
                obj.id = id;
                obj.apiUrl = this.apiConfig.publicityDetail;
                let data = await this.$store.dispatch("apiEvent", obj);
                if (data == "000104") {
                    this.timeoutEvent();
                    return;
                }
                if (!data) return;
                data.data.result.selectDate = []
                data.data.result.lstPublicityLangMapDTO = data.data.result.lstPublicityLangMapDTO.map(i => {
                    return {
                        ...i,
                        videoImgList: [...i.lstPublicityVideo, ...i.lstPublicityImagesDTO],
                        lstPublicityAttachmentDTO: i.lstPublicityAttachmentDTO.map(item => {
                            return { ...item, name: item.fileName }
                        }),
                        imageListIsNull: [...i.lstPublicityVideo, ...i.lstPublicityImagesDTO].length ? "no" : '',
                        documentListIsNull: i.lstPublicityAttachmentDTO ? "no" : ''
                    }
                })
                data.data.result.lstPublicityLangMapDTO.forEach(i => {
                    i.videoImgList = this.$lodash.sortBy(i.videoImgList, (file) => {
                        return file.sortOrder
                    })
                    i.videoImgList = i.videoImgList.map((file, fileIndex) => {
                        return {
                            ...file,
                            sortOrder: fileIndex
                        }
                    })
                })


                data.data.result.selectDate[0] = data.data.result.begDate || ''
                data.data.result.selectDate[1] = data.data.result.endDate || ''
                if (data.data.result.parentId) data.data.result.parentId = this.$route.query.parentId ? Number(this.$route.query.parentId) : this.$route.query.parentId
                this.$set(this, "detailInfo", data.data.result);
                setTimeout(function () {
                    that.$store.state.edit = false;
                }, 500);
            } else {
                this.detailInfo.parentId = this.$route.query.parentId
                setTimeout(function () {
                    that.$store.state.edit = false;
                }, 500);
            }
        },
        checkEvent: function () {
            this.$refs["detailInfo"].validate(valid => {
                if (valid) {
                    this.submit();
                } else {
                    this.$toastr.w(this.$i18n.t("message.fillRequired"));
                    return false;
                }
            });
        },
        showWarning(type) {
            var that = this;
            if (!type) {
                that.$router.go(-1);
            } else if (type == 1) {
                this.$store.commit("setwarning", {
                    string: this.$i18n.t("message.deleteContent"),
                    boolean: true,
                    button: [
                        {
                            name: this.$i18n.t("message.Confirm"),
                            callBack: function () {
                                that.$store.commit("setwarning", {
                                    string: "",
                                    boolean: false
                                });
                                that.callDelete();
                            }
                        },
                        {
                            name: this.$i18n.t("message.Cancel"),
                            callBack: function () {
                                that.$store.commit("setwarning", {
                                    string: "",
                                    boolean: false
                                });
                            }
                        }
                    ]
                });
            }
        },
        async submit() {
            // https://player.vimeo.com/external/528658575.sd.mp4?s=b079adf4a64a60d721760f0e8055dbac3a33e8fd&profile_id=165
            try {
                let obj = this.getAuthObj();
                const list = this.$lodash.cloneDeep(this.detailInfo.lstPublicityLangMapDTO)
                list.forEach((i) => {
                    i.lstPublicityImagesDTO = i.videoImgList.filter(file => {
                        return file.fileType == 1
                    })
                    i.lstPublicityVideo = i.videoImgList.filter(file => {
                        return file.fileType == 3
                    })
                    delete i.imageListIsNull
                    delete i.documentListIsNull
                    delete i.videoImgList
                })

                obj.lstPublicityLangMapDTO = list
                obj.begDate = this.detailInfo.selectDate[0] ? this.$dayjs(this.detailInfo.selectDate[0]).format("YYYY-MM-DD HH:mm:ss") : ''
                obj.endDate = this.detailInfo.selectDate[1] ? this.$dayjs(this.detailInfo.selectDate[1]).format("YYYY-MM-DD HH:mm:ss") : ''
                obj = { ...this.detailInfo, ...obj }
                delete obj.selectDate
                var data;
                if (this.$route.query.id) {
                    obj.id = this.detailInfo.id || this.$route.query.id;
                    obj.apiUrl = this.apiConfig.publicityUpdate;
                    data = await this.$store.dispatch("apiEvent", obj);
                } else {
                    obj.apiUrl = this.apiConfig.publicityCreate;
                    data = await this.$store.dispatch("apiEvent", obj);
                }
                if (data == "000104") {
                    this.timeoutEvent();
                    return;
                }
                if (!data) return;
                if (data.data.status_code === "0") {
                    this.$store.state.edit = false;
                    this.$router.go(-1);
                }
            } catch (err) { console.log("err:", err) }
        },
        Delete() {
            this.showWarning(1);
        },
        async callDelete() {
        },
        setBreadcrumbs: function () {
            if (this.$route.path == "/main/publicitySubDetail") {
                var breadcrumbs = this.$route.meta.breadcrumbs.find(
                    b => b.to == "/main/publicityDetail"
                );
                if (breadcrumbs) {
                    breadcrumbs.to = "/main/publicityDetail?id=" + this.$route.query.parentId;
                }
            }
        },
    }
};
</script>